import { React, useEffect } from 'react'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import { colors } from 'globalStyles'
import PropTypes from 'prop-types'
import SignaturePreference from './SignaturePreference'
import LocationPreference from './LocationPreference'
import BuzzerCodePreference from './BuzzerCodePreference'
import DeliveryInstructionsPreference from './DeliveryInstructionsPreference'

const StyledBaseDiv = styled.div`
  display: flex;
  flex-direction: row !important;
  position: relative;
  padding: 8px 4px;
  border-radius: 8px 0px;
  min-height: 52px;
  width: 100%;
  border-radius: 8px 0px;
  display: block;
`
const StyledTitle = styled.div`
  text-align: center;
  color: ${colors.dark_blue};
  font-weight: 600;
  font-size: 18px;
}`

const StyledDiv = styled.div`
  font-size: 14px;
  line-height: 20px;
  margin-top: 25px;
  text-align: center;
`
const MyPreferences = ({ userPreferenceDetails }) => {
  const { t, i18n } = useTranslation()
  const { lang } = useParams()
  const { language } = i18n

  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
  }, [lang, i18n, language])

  return (
    <>
      <StyledBaseDiv>
        <StyledTitle>{t(`my_preferences.set_preferences_title`)}</StyledTitle>
        <StyledDiv>
          <Trans i18nKey="my_preferences.set_preferences_msg" />
        </StyledDiv>
      </StyledBaseDiv>
      <SignaturePreference userPreferenceDetails={userPreferenceDetails} />
      <LocationPreference userPreferenceDetails={userPreferenceDetails} />
      <BuzzerCodePreference userPreferenceDetails={userPreferenceDetails} />
      <DeliveryInstructionsPreference userPreferenceDetails={userPreferenceDetails} />
    </>
  )
}

MyPreferences.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  userPreferenceDetails: PropTypes.object.isRequired,
}

export default MyPreferences
